import MovieCard from "@/components/feature/MovieCard";
import SectionHeading from "@/components/feature/SectionHeading";
import type { Movie } from "@/types/movie";

interface FeaturedSectionProps {
  title: string;
  subtitle: string;
  movies: Movie[];
  moreTo: string;
  tone?: "plain" | "tinted";
}

export default function FeaturedSection({
  title,
  subtitle,
  movies,
  moreTo,
  tone = "plain",
}: FeaturedSectionProps) {
  return (
    <section className={tone === "tinted" ? "bg-background-100" : ""}>
      <div className="mx-auto w-full max-w-7xl px-4 py-10 md:px-6 md:py-14">
        <SectionHeading title={title} subtitle={subtitle} moreTo={moreTo} />
        <div className="grid grid-cols-2 gap-3 sm:grid-cols-3 md:gap-4 lg:grid-cols-6">
          {movies.map((movie) => (
            <MovieCard key={movie.id} movie={movie} />
          ))}
        </div>
      </div>
    </section>
  );
}